import { apiGET, apiPOST, apiDELETE } from './api';

export const getUserNotificationsPreferences = userId => {
  return apiGET(`/users/${userId}/notifications_preferences`);
};

export const storeOrUpdate = (userId, body) => {
  return apiPOST(`/users/${userId}/notifications_preferences`, body);
};

export const applyNativePushSwitchover = userId => {
  return apiPOST(`/users/${userId}/notifications_preferences/native-push-switchover`);
};

export const resetUserNotificationsPreferences = userId => {
  return apiDELETE(`/users/${userId}/notifications_preferences`);
};
